// 系统设置模块页面级国际化

export default {
  // ─── 更新日志 ──────────────────────────────────────────────────────────────
  'system.changelog.type.feature': '新功能',
  'system.changelog.type.improve': '优化',
  'system.changelog.type.fix': '修复',
  'system.changelog.type.breaking': '重要',
  'system.changelog.tag.latest': '最新',
  'system.changelog.tag.current': '当前',

  // ─── 全局配置 ──────────────────────────────────────────────────────────────
  'system.config.save': '保存',

  // 密码策略
  'system.config.pwd.tab': '密码策略',
  'system.config.pwd.title': '密码策略',
  'system.config.pwd.desc': '配置用户密码修改周期',
  'system.config.pwd.expireDays.label': '密码有效期（天）',
  'system.config.pwd.expireDays.tooltip': '用户须在此周期内修改密码，设置为 0 表示不限制',
  'system.config.pwd.expireDays.required': '请输入天数',
  'system.config.pwd.maxError.label': '密码最大错误次数',
  'system.config.pwd.maxError.tooltip': '在统计时间窗口内，连续输错密码超过该次数后账号将被禁用，设置为 0 表示不限制',
  'system.config.pwd.maxError.required': '请输入最大错误次数',
  'system.config.pwd.errorWindow.label': '错误次数统计时间窗口（小时）',
  'system.config.pwd.errorWindow.tooltip': '在该时间窗口内累计错误次数达到上限后账号将被禁用，设置为 0 表示不限制',
  'system.config.pwd.errorWindow.required': '请输入时间窗口小时数',
  'system.config.pwd.save.success': '密码策略保存成功',

  // 邮件配置
  'system.config.email.tab': '邮件配置',
  'system.config.email.title': '邮件配置',
  'system.config.email.desc': '配置系统邮件发送方式，支持 SMTP 或 Postmark API',
  'system.config.email.sendType.label': '发送方式',
  'system.config.email.sendType.smtp': 'SMTP',
  'system.config.email.sendType.postmark': 'Postmark API',
  'system.config.email.sendType.required': '请选择发送方式',
  'system.config.email.host.label': 'SMTP 服务器',
  'system.config.email.host.required': '请输入 SMTP 服务器地址',
  'system.config.email.port.label': '端口',
  'system.config.email.port.required': '请输入端口',
  'system.config.email.encrypt.label': '加密方式',
  'system.config.email.encrypt.required': '请选择加密方式',
  'system.config.email.encrypt.placeholder': '请选择',
  'system.config.email.username.label': '账号',
  'system.config.email.username.required': '请输入账号',
  'system.config.email.username.placeholder': '邮箱账号',
  'system.config.email.fromEmail.label': '发件人邮箱',
  'system.config.email.fromEmail.required': '请输入发件人邮箱',
  'system.config.email.fromEmail.invalid': '请输入有效的邮箱地址',
  'system.config.email.fromName.label': '发件人名称',
  'system.config.email.fromName.required': '请输入发件人名称',
  'system.config.email.fromName.placeholder': '如：系统通知',
  'system.config.email.authCode.label': '授权码',
  'system.config.email.authCode.required': '请输入邮箱授权码',
  'system.config.email.authCode.placeholder': '邮箱授权码或应用专用密码',
  'system.config.email.save.success': '邮件配置保存成功',

  // 邮件模板
  'system.config.template.tab': '邮件模板',
  'system.config.template.add.title': '新增用户邮件模板',
  'system.config.template.add.desc': "配置新增用户时发送的邮件内容，支持变量 '{userAccount}'、'{password}'",
  'system.config.template.reset.title': '重置密码邮件模板',
  'system.config.template.reset.desc': "配置用户重置密码时发送的邮件内容，支持变量 '{userAccount}'、'{resetLink}'",
  'system.config.template.subject.label': '邮件标题',
  'system.config.template.subject.required': '请输入邮件标题',
  'system.config.template.content.label': '邮件模板内容',
  'system.config.template.content.required': '请输入邮件模板内容',
  'system.config.template.content.extra': '支持换行，直接按 Enter 分段，发送时将自动保留段落格式',
  'system.config.template.add.save.success': '邮件模板保存成功',
  'system.config.template.reset.save.success': '重置密码邮件模板保存成功',
  'system.config.template.forget.title': '忘记密码邮件模板',
  'system.config.template.forget.title.placeholder': '如：忘记密码邮件',
  'system.config.template.forget.desc': "配置用户忘记密码时发送的邮件内容，支持变量 '{authCode}'",
  'system.config.template.forget.desc.placeholder': "请点击按钮重置密码 http://example.com?authCode='{authCode}'，15分钟内有效",
  'system.config.template.forget.content.extra': "支持换行，直接按 Enter 分段，发送时将自动保留段落格式。可使用变量 '{authCode}'",
  'system.config.template.forget.save.success': '忘记密码邮件模板保存成功',

  // 上传文件配置
  'system.config.storage.tab': '上传文件配置',
  'system.config.storage.title': '上传文件容量设定',
  'system.config.storage.desc': '设置单人、单公司及整个租户的文件上传容量上限，0 表示不限制',
  'system.config.storage.user.label': '单人容量上限（MB）',
  'system.config.storage.user.tooltip': '每个用户累计可上传的文件总量，0 表示不限制',
  'system.config.storage.user.required': '请输入单人容量上限',
  'system.config.storage.company.label': '单公司容量上限（MB）',
  'system.config.storage.company.tooltip': '每个公司下所有用户累计可上传的文件总量，0 表示不限制',
  'system.config.storage.company.required': '请输入单公司容量上限',
  'system.config.storage.tenant.label': '整个租户容量上限（MB）',
  'system.config.storage.tenant.tooltip': '该租户下所有公司的文件上传总量上限，0 表示不限制',
  'system.config.storage.tenant.required': '请输入租户容量上限',
  'system.config.storage.save.success': '上传容量配置保存成功',

  // ─── 应用信息 ──────────────────────────────────────────────────────────────
  'system.info.version.title': '版本信息',
  'system.info.version.current': '当前版本',
  'system.info.version.latest': '最新版本',
  'system.info.version.build': '构建版本',
  'system.info.version.serviceStatus': '服务状态',
  'system.info.version.status.ok': '正常运行',
  'system.info.version.status.error': '运行异常',
  'system.info.update.title': '系统更新',
  'system.info.update.hasNew': '有新版本',
  'system.info.update.desc': '需要配置后才能使用',
  'system.info.update.btn': '配置软件更新',
  'system.info.client.title': '客户端地址',
  'system.info.client.desc': '客户端支持 管理端、客户端',
  'system.info.client.btn': '进入客户端',
  'system.info.docs.title': '帮助文档',
  'system.info.docs.desc': '查看完整的产品文档，了解如何使用各项功能',
  'system.info.docs.btn': '查看文档',
  'system.info.docker.title': 'Docker 镜像',
  'system.info.docker.desc': '后台系统通过 Docker 镜像发布，查看最新版本',
  'system.info.docker.btn': 'Docker Hub',

  // ─── 授权管理 ──────────────────────────────────────────────────────────────
  'system.license.status.valid': '有效',
  'system.license.status.invalid': '无效',
  'system.license.status.expired': '已过期',
  'system.license.authorized': '系统已授权',
  'system.license.unauthorized': '系统未授权',
  'system.license.authorizedDesc': '当前系统已有有效的 License 授权。',
  'system.license.unauthorizedDesc': '当前系统暂无有效授权，请联系管理员获取 License。',
  'system.license.statusLabel': '授权状态',
  'system.license.running': '正常运行',
  'system.license.notAuthorized': '未授权',
  'system.license.info.title': '当前 License 信息',
  'system.license.info.desc': '显示当前系统的 License 授权状态',
  'system.license.field.activateTime': '激活时间',
  'system.license.field.expireTime': '过期时间',
  'system.license.field.status': '状态',
  'system.license.field.company': '公司名称',
  'system.license.field.userLimit': '用户限制',
  'system.license.field.features': '授权功能',
  'system.license.expireSoon': '即将到期',
  'system.license.refresh': '点击刷新授权信息',

  // ─── 菜单配置 ──────────────────────────────────────────────────────────────
  'system.menu.title': '菜单配置',
  'system.menu.empty': '暂无菜单',
  'system.menu.save': '保存修改',
  'system.menu.sort.success': '排序已保存',
  'system.menu.sort.fail': '排序保存失败',
  'system.menu.detail.empty': '请选择左侧菜单查看详情',
  'system.menu.form.basicInfo': '基本信息',
  'system.menu.form.configSettings': '配置设置',
  'system.menu.form.name.label': '菜单名称',
  'system.menu.form.name.placeholder': '请输入菜单名称',
  'system.menu.form.name.required': '请输入菜单名称',
  'system.menu.form.name.tooltip': '菜单在侧边栏显示的名称',
  'system.menu.form.path.label': '路由路径',
  'system.menu.form.path.placeholder': '请输入路由路径',
  'system.menu.form.path.tooltip': '对应的前端路由路径，唯一标识',
  'system.menu.form.icon.label': '菜单图标',
  'system.menu.form.icon.tooltip': '菜单左侧显示的图标',
  'system.menu.form.sort.label': '排序值',
  'system.menu.form.sort.tooltip': '菜单显示的顺序',
  'system.menu.form.remark.label': '备注',
  'system.menu.form.remark.placeholder': '请输入备注',
  'system.menu.tree.button': '按钮',
  'system.menu.tree.disabled': '禁用',

  // ─── 更新日志条目 ────────────────────────────────────────────────────────────
  // v0.0.8
  'system.changelog.v008.item0': '新增 Token 消耗统计与配额管理（入口：用户管理-配额、公司管理-配额）',
  'system.changelog.v008.item1': '用户管理新增 Excel 批量导入，支持批量创建用户',
  'system.changelog.v008.item2': '新增工作台 / 应用综合查询面板',
  'system.changelog.v008.item3': '新增系统设置模块：全局配置 / 授权管理 / 更新日志 / 应用信息',
  'system.changelog.v008.item4': '全局搜索框新增模糊查询（操作日志除外，因数据量较大）',
  'system.changelog.v008.item5': '部分列表新增状态快捷筛选',
  'system.changelog.v008.item6': '新增用户注册邮件通知及邮件模板配置',
  'system.changelog.v008.item7': '全局列表新增字段排序功能',
  'system.changelog.v008.item8': '优化列表字段自定义、本地保存及导出报表字段同步',
  'system.changelog.v008.item9': '优化侧边栏菜单折叠与展开逻辑',
  'system.changelog.v008.item10': '优化部分页面交互体验',
  // v0.0.7
  'system.changelog.v007.item0': '新增应用 Token 消耗排名，支持按应用、公司、用户维度查看',
  'system.changelog.v007.item1': '新增所有菜单排序切换，所有搜索栏目模糊搜索',
  'system.changelog.v007.item2': '优化菜单国际化缓存处理逻辑，提升切换语言速度',
  'system.changelog.v007.item3': '应用分析模块重构，删除废弃模拟数据组件',
  'system.changelog.v007.item4': '修复应用缓存在多用户场景下数据混用的问题',
};
